@if (naam$ | async; as naam) {
    <span class="downloads-naam">
        <span class="downloads-naam__title -sh-wrap">{{ naam.title }}</span>
        @if (naam.subtitle; as subtitle) {
            &nbsp;<span class="downloads-naam__subtitle">{{ subtitle.key | translate: subtitle.params }}</span>
        }
    </span>
}
